import useHomeContext from 'Context/HomeContext';
import Sentry from 'Integrations/Sentry';


const getUtmValue = (paramName) => {
  // We need to attempt to extract our tracking data from the url params (for traffic coming directly from an ad)
  // or from the _campaign_data cookie (for traffic coming from the marketing site -> the quiz.)
  // The url will look something like: http://localhost:3000/discover?hello=world&utm_source=facebook
  // The campaign data cookie will look something like: https%3A%2F%2Ffacet.com%2Ftest-eqf%2F%3Futm_source%3Dtesting-only%26utm_campaign%3Deqf-test%26utm_medium%3Dpaid-media%26utm_content%3Deqf-test%26gclid%3D1234123513412341
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get(paramName);
  if (paramValue) {
    return paramValue;
  }

  const campaignDataPattern = /_campaign_data=([^;]+)/;
  const campaignDataMatch = document.cookie.match(campaignDataPattern);
  if (campaignDataMatch) {
    try {
      const campaignData = decodeURIComponent(campaignDataMatch[1]);
      const campaignParams = new URLSearchParams(campaignData.split('?')[1]);
      const cookieParamValue = campaignParams.get(paramName);
      if (cookieParamValue) {
        return cookieParamValue;
      }
    } catch (err) {
      Sentry.createSentryErrorLog(err);
    }
  }

  return null;
};


export const getUtmSource = (homeResource) => {
  let fallbackUTMSource = homeResource.attr('eqfSourceFallback');
  const influencerPathNames = homeResource.attr('eqfInfluencerPaths');

  if (influencerPathNames && influencerPathNames.length > 0) {
    // if we're on one of the influencer quizzes, set the fallback utm_source to 'influencer'
    const lastPathname = window.location.pathname.split('/').pop();
    if (influencerPathNames.includes(lastPathname)) {
      fallbackUTMSource = homeResource.attr('eqfInfluencerSourceFallback');
    }
  }

  // We need to attempt to find the utm_source either in the url params or in the campaign data cookie.
  // If we have a source in the url params we should take that one. Next, if we have a source in the
  // cookie we should take that one. Lastly if we have neither we should fall back to Facet.com
  return getUtmValue('utm_source') || fallbackUTMSource;
};

const buildCommonFQEventProperties = (resource, homeResource) => {
  return {
    responseId: resource.id(),
    quizId: resource.attr('quizId'),
    qualificationTier: resource.attr('qualificationTier'),
    utmSource: getUtmSource(homeResource),
    utmContent: getUtmValue('utm_content'),
    utmCampaign: getUtmValue('utm_campaign'),
    utmCmp: getUtmValue('utm_cmp'),
    utmAdg: getUtmValue('utm_adg'),
    utmAd: getUtmValue('utm_ad'),
    utmTerm: getUtmValue('utm_term'),
    quizTakerHouseholdId: getUtmValue('quizTakerHouseholdId'),
    visitorSessionUUID: homeResource.attr('visitorSessionUuid'),
  };
};

export const useBuildCommonFQEventProperties = () => {
  const { homeResource } = useHomeContext();
  return {
    buildCommonFQEventProperties: (resource) => buildCommonFQEventProperties(resource, homeResource),
  };
};
